/** @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/core';

export interface Props {
  logo: string | undefined;
  id: string;
}

const BreadIcon = (props: Props) => {
  const { logo, id } = props;
  const svg = logo ? Buffer.from(logo, 'base64').toString('ascii') : '';

  return (
    <React.Fragment>
      <div
        dangerouslySetInnerHTML={{
          __html: svg
            .replace('id="svg"', `id=${id}-svg`)
            .replace('id="svgg"', `id=${id}-svgg`)
            .replace(/id="path/g, `id="${id}-path`),
        }}
      />
    </React.Fragment>
  );
};

export default BreadIcon;
